import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { ImageDataType } from "../../../commonTypes/fileManagerTypes";
import {
  CloseIcon,
  NewWhiteDownloadIcon,
  NoFile,
  RedDeleteIcon,
  UnPreviewImage
} from "../../../assets/images";

import "../../../components/FileManager/Files/Files.scss";
import { FileDataType } from "../../../commonTypes/universalTypes";
import PdfPreview from "../../../components/FileManager/Files/PdfPreview";

type AppProps = {
  resetImageUrl: () => void;
  setShowImagePreview: (data: any) => void;
  imageDetails: ImageDataType | undefined;
  renderFilesList: Function;
  showImagePreview: boolean;
  uploadData: FileDataType[] | [];
  setUploadData: React.Dispatch<React.SetStateAction<any[]>>;
  type?: string;
  handleEditFileList?: Function;
  isDelete?: boolean;
};

let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
let blobToken = process.env.REACT_APP_BLOB_TOEKN;

const ImageModal = ({
  imageDetails,
  resetImageUrl,
  setShowImagePreview,
  renderFilesList,
  showImagePreview,
  uploadData,
  setUploadData,
  type,
  isDelete,
  handleEditFileList,
}: AppProps) => {
  const toggle = () => {
    setShowImagePreview(!showImagePreview);
    if (type != "jobDetails") {
      setUploadData([]);
    }
  };
  const imageList = renderFilesList();
  const handleDownload = async () => {
      const response = await fetch(
        `${blobBaseUrl}${imageDetails?.downloadImage}?${blobToken}`
      );
      const blob = await response.blob(); 
      const url = window.URL.createObjectURL(blob);
  
      const a = document.createElement("a");
      a.href = url;
      a.download = imageDetails?.finalFileName || "downloaded_file";
      document.body.appendChild(a);
      a.click();
      a.remove(); 
  
      window.URL.revokeObjectURL(url); 
  };

  return (
    <Modal isOpen={showImagePreview} size="lg">
      <div
        className="d-flex justify-content-between md-col-12 mt-3"
        style={{ borderBottom: "1px solid #bfcbe1" }}
      >
        <div style={{ marginTop: "-13px" }}>
          <h4 className="header ml-4 mb-0">View Files</h4>
        </div>
        <div
          className="pointer mr-3 d-flex align-items-center"
          style={{ marginTop: "-13px" }}
        >
          <span
            onClick={() => {
              toggle();
              resetImageUrl();
            }}
          >
            <img src={CloseIcon} alt="close"/>
          </span>
        </div>
      </div>
      <div className="d-flex justify-content-between"></div>
      <ModalBody style={{ padding: 0, display: "flex", width: "100%" }}>
        {uploadData?.length ? (
          <ul
            style={{
              width: uploadData?.length === 1 ? "" : "23%",
              borderRight: uploadData?.length !== 1 ? "1px solid #bfcbe1" : "",
              marginRight: "2%",
              marginLeft: "-2%",
              marginTop: "2%",
              maxHeight: "440px",
              overflowY: "auto",
              color: "black",
            }}
          >
            {uploadData?.length !== 1 && imageList}
          </ul>
        ) : (
          ""
        )}
        {uploadData?.length ? (
          <div
            style={{
              width: uploadData?.length !== 1 ? "75.5%" : "92%",
              paddingBottom: "2%",
              minHeight: "70vh",
            }}
          >
            <div className="d-flex justify-content-between mt-2 mb-2">
              <p style={{ fontSize: "14px" }} className="mt-2">
                {imageDetails?.finalFileName &&
                imageDetails?.finalFileName?.length > 40
                  ? imageDetails?.finalFileName?.slice(0, 40) + "..."
                  : imageDetails?.finalFileName}
              </p>
              <div className="d-flex">
                {isDelete && (
                  <div className="mr-2" style={{ marginTop: "5px" }}>
                    {" "}
                    <img
                      className="pointer"
                      onClick={() =>
                        handleEditFileList?.(imageDetails?.file_url)
                      }
                      style={{ height: "26px" }}
                      src={RedDeleteIcon}
                      alt="delete"
                    />
                  </div>
                )}
                <div>
                  {blobBaseUrl && imageDetails?.downloadImage && (
                    
                      <button className="btn btn-primary" onClick={handleDownload}>
                        <span className="pr-2">
                          <img src={NewWhiteDownloadIcon} alt="download"/>
                        </span>
                        Download
                      </button>
                  )}
                </div>
              </div>
            </div>
            <div>
              {imageDetails?.fileType === "application/msword" ||
              imageDetails?.fileType === "application/vnd.ms-excel" ||
              imageDetails?.fileType ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
              imageDetails?.fileType ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
              imageDetails?.fileType === "application/vnd.ms-powerpoint" ||
              imageDetails?.fileType ===
                "application/vnd.openxmlformats-officedocument.presentationml.presentation" ? (
                blobBaseUrl &&
                imageDetails?.downloadImage && (
                  <iframe
                    width="100%"
                    height="350px"
                    src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
                      blobBaseUrl +
                        imageDetails?.downloadImage +
                        "?" +
                        blobToken
                    )}`}
                  />
                )
              ) : imageDetails?.fileType === "text/csv" ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    height: "350px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "100%", height: "350px" }}>
                    <img
                      style={{
                        objectFit: "cover",
                        height: "100%",
                        width: "100%",
                      }}
                      src={UnPreviewImage}
                      alt="preview"
                    />
                  </div>
                </div>
              ) : imageDetails?.fileType === "application/pdf" ? (
                <PdfPreview imageDetails={imageDetails} />
              ) : (
                <img
                  style={{ objectFit: "cover", width: "100%", height: "350px" }}
                  src={imageDetails?.imageUrl}
                  alt="url"
                />
              )}
            </div>
          </div>
        ) : (
          <div style={{ height: "400px", margin: "auto" }}>
            <div className=" mt-5">
              <img
                src={NoFile}
                alt="no-file"
                style={{ width: "200px" }}
                className="mb-5"
              />
              <h1 style={{ textAlign: "center" }}>No files</h1>

              <span className="sub-text"></span>
            </div>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ImageModal;
